import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Input from '../../blocks/Input';
import styles from './SearchableSelect.module.scss';
import cn from 'classnames';

function SearchableSelect(props) {
  const { value, options, canSelect = true } = props;

  let [search, setSearch] = useState('');
  let [visible, setVisible] = useState(options);
  let [selected, setSelected] = useState(value || null);

  useEffect(() => {
    if (!search) {
      setVisible(options);
    } else {
      const searchQuery = search.toLowerCase();
      const visible = options.filter((item) => item.key === selected || item.value.toLowerCase().includes(searchQuery));
      setVisible(visible);
    }
  }, [options, search, selected]);

  const handleChange = (key) => {
    if (canSelect) {
      setSelected(key);
    }
    props.onChange && props.onChange(key);
  };

  return (
    <>
      <div className={styles.search}>
        <Input placeholder="Search…" onChange={(e) => setSearch(e.target.value)} value={search} />
      </div>
      <ul className={styles.searchableList}>
        {visible.map((item, i) => (
          <li
            className={value === item.key ? styles.selected : ''}
            key={item.key}
            onClick={(e) => handleChange(item.key)}
          >
            {item.image && (
              <span className={styles.image}>
                <img src={item.image} alt={item.value} />
              </span>
            )}
            <span className={styles.title}>{item.value}</span>
            {item.button && (
              <span className={cn(styles.button, item.showAlways ? styles.showAlways : '')}>{item.button}</span>
            )}
          </li>
        ))}
      </ul>
    </>
  );
}

export default SearchableSelect;

SearchableSelect.propTypes = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      image: PropTypes.string,
      button: PropTypes.element,
    }),
  ).isRequired,
  onChange: PropTypes.func,
  canSelect: PropTypes.bool,
};
